export default "__VITE_ASSET__R_s2XgHe__"